export default "__VITE_ASSET__a6990a8f__"